import React, { useContext, useState } from 'react';

const ApplicationDataContext = React.createContext();
export const ApplicationDataProvider = ({ children }) => {
  const [sysPanel, setSysPanel] = useState({
    notifications: false,
    userSettings: false
  });

  return (
    <ApplicationDataContext.Provider value={{ sysPanel, setSysPanel }}>
      {children}
    </ApplicationDataContext.Provider>
  );
};

export default function useApplicationData() {
  const context = useContext(ApplicationDataContext);
  return context;
}